import {retrieveRequestFactory, RETRIEVE_SUCCESS, RETRIEVE_ERROR, RETRIEVE_REQUEST} from 'store/generic/actions';

export const COLLECTION_NAME = 'DIFFICULTY';

export const RETRIEVE_DIFFICULTIES_REQUEST = RETRIEVE_REQUEST + '_' + COLLECTION_NAME;
export const RETRIEVE_DIFFICULTIES_ERROR = RETRIEVE_ERROR + '_' + COLLECTION_NAME;
export const RETRIEVE_DIFFICULTIES_SUCCESS = RETRIEVE_SUCCESS + '_' + COLLECTION_NAME;

export const setDifficulties = (payload) => ({
    type: RETRIEVE_DIFFICULTIES_SUCCESS,
    difficulties: payload.difficulties,
});

export const retrieveDifficulties = retrieveRequestFactory('difficulties', COLLECTION_NAME, true, setDifficulties);



// WEBPACK FOOTER //
// ./src/store/difficulties/actions.js